module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUxMiAyMzQuNWwzNC4zLTM0LjdhMjQwLjMgMjQwLjMgMCAwIDEgMzQyLjcgMGM5Mi42IDkzLjcgOTQuNiAyNDQuMyA2IDM0MC40TDUzNC44IDkwNWEzMiAzMiAwIDAgMS00NS41IDBMMTM1IDU0Ni42Yy05NC42LTk1LjctOTQuNi0yNTEgMC0zNDYuOGEyNDAuMyAyNDAuMyAwIDAgMSAzNDIuNyAwTDUxMiAyMzQuNmwzNC4zLTM0LjdMNTEyIDIzNC42eiIgZmlsbD0iIzAiIHAtaWQ9IjM3MTEiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Favorite-filled.svg
// module id = pEtN
// module chunks = 74